import React, {useLayoutEffect} from "react"
import ModalMoveTo_ProjectsTree from "./tree"
import {SpaceProto} from "../../../../model2/space/space-proto"
import Workspace from "../../../../model2/space/workspaces/workspace"
import {
    selectParent_filter,
    selectParent_recursiveUpdateExpandState,
    selectParent_searchAndFilter
} from "../../../../gd-ui/select-parent-new/actions/filter"
import {useForceUpdate} from "../../../../gd/utils/dom-and-react/react-utils"
import {MoveTo_Manager} from "../../model/manager"
import SearchInput from "../../../../gd-ui/search/search"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import ProjectSession from "../../../../model2/project/project-session"
import ModalMoveTo_NoResultsFound from "./no-results-found"
import Modal_Submit from "../../../components/submit/submit"
import {ItemDisplay} from "../../../../model2/item/@type";

type Props = {
    manager : MoveTo_Manager
}

// const debug = "ModalMoveTo_SelectFolder"
const debug = false

export default function ModalMoveTo_SelectFolder(props: Props) {

    const forceUpdate = useForceUpdate()

    const manager = props.manager

    const availableProjects = manager.availableProjects

    const spaces = _.filter(gd.spaces.spacesWithProjects, (space: SpaceProto) => space.enabled)

    const updateInitialExpand = () => {
        const selectedProjectsIds = manager.targetProject?.id ? [manager.targetProject.id] : undefined

        debug && console.log(debug, 'updateInitialExpand', selectedProjectsIds)

        _.map(spaces, (space: SpaceProto) => {
            const project = (space as Workspace).project
            if (project) {
                project.treeIsExpandedProjectSelector = false
            }

            const expandSelectedProjects = selectedProjectsIds?.length === 1

            // update initial expand state for each project
            selectParent_recursiveUpdateExpandState(
                space,
                selectedProjectsIds,
                availableProjects,
                expandSelectedProjects
            )
        })
    }

    useLayoutEffect(() => {
        updateInitialExpand()

        debug && console.log(debug, 'useLayoutEffect', _.map(spaces, (space: SpaceProto) => space.rootProjects))

        forceUpdate()
    }, [])

    const onSearchChange = (value: string) => {
        // restore expanded projects if search string is empty
        if (!value) {
            updateInitialExpand()
        }

        props.manager.setSearchPrompt(value)
    }

    let matchedProjects

    if (manager.searchEnabled) {
        matchedProjects = selectParent_searchAndFilter(manager.searchPrompt, manager.parentsFor, availableProjects)
    } else {
        matchedProjects = gd.session.projects.treeRoots
        selectParent_filter(gd.session.projects.treeRoots, manager.parentsFor, availableProjects)
    }

    const nothingFound              = !_.some(matchedProjects, (projectSession: ProjectSession) => {
        return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(projectSession.treeDisplay)
    })

    const selectedIsVisible         = !manager.targetProject || manager.targetProject.treeDisplay === ItemDisplay.VISIBLE
    const isTargetProjectAvailable  = manager.isTargetProjectAvailable
    const submitAvailable           = isTargetProjectAvailable && selectedIsVisible && !nothingFound

    return (
        <>
            <div className="p-h-20 m-b-20">
                <SearchInput value={manager.searchPrompt} onChange={onSearchChange}  />
            </div>

            <div className="flex-row-left-top flex-1" style={{height: 'calc(100% - 50px - 90px)'}}>
                {nothingFound &&
                    <ModalMoveTo_NoResultsFound />}

                {!nothingFound &&
                    <ModalMoveTo_ProjectsTree manager={manager}/>}
            </div>

            <Modal_Submit type      = {submitAvailable ? ButtonType.PRIMARY : ButtonType.DISABLED}
                          label     = "Submit"
                          onSubmit  = {submitAvailable ? manager.validateUsers : undefined}/>
        </>
    )
}